import { getData } from "../api/API";

export let company;

export const fetchCompanyDetails = async () => {
  try {
    const response = await getData("company");
    company = response;
    const companyTheme = company?.data?.[0]?.doc?.[0]?.company_theme || "soochi";  
    document.documentElement.className = companyTheme + "-theme";  
    setCompanyTheme(companyTheme);  
    return response;
  } catch (error) {
    console.error("Error fetching company details:", error);
  } 
};

export const getCompanyDetails = async () => {
  if (company?.data?.[0]?.doc?.[0]) {
    return company.data[0].doc[0];
  }
  const res = await fetchCompanyDetails();
  return res?.data?.[0]?.doc?.[0] || null;
};

export const setCompanyTheme = async (theme) => {
  try {
    localStorage.setItem("company_theme", theme);  
  } catch (error) {
    
  }
};

export const getCompanyTheme = () => {
  return localStorage.getItem("company_theme") ;  
};

export const initializeTheme = async () => {
  const storedTheme = getCompanyTheme();

  if (storedTheme) {
    document.documentElement.className = storedTheme + "-theme";  
  } else {
    await fetchCompanyDetails();  
  }
};

initializeTheme();

